import { Component, Input } from '@angular/core';
import { I18NDescriptor } from '../../uikit.interface';

@Component({
  selector: 'va-legend-item',
  templateUrl: './va-legend-item.component.html',
  styleUrls: ['./va-legend-item.component.scss'],
})
export class VaLegendItemComponent {
  @Input() color: string;
  @Input() label: I18NDescriptor;
  @Input() valueLabel: string;
}
